<svg width="500" height="500">
    <circle r="250" cx="250" cy="250" class="red w100 circle"/>
    <text x="50%" y="50%" text-anchor="middle" stroke-width="2px" dy=".3em">100%</text>
    <circle r="250" cx="250" cy="250" class="yellow w50 circle"/>
    <text x="50%" y="50%" text-anchor="middle" stroke="#51c5cf" stroke-width="2px" dy=".3em">50%</text>
</svg>